export const players = [
    {
        id: 1,
        name: "Manuel Neuer",
        position: " GK ",
        nationality: "Germany",
        number: 1,
        starter: true,
        image: "/Images/Manuel-Neuer.png"
    },

    {
        id: 2,
        name: "Sven Ulreich",
        position: " GK ",
        nationality: "Germany",
        number: 26,
        starter: false,
        image: "/Images/Sven-Ulreich.png"
    },

    {
        id: 3,
        name: "Jonas Urbig",
        position: " GK ",
        nationality: "Germany",
        number: 40,
        starter: false,
        image: "/Images/Jonas-Urbig.png"
    },

    {
        id: 4,
        name: "Alphonso Davies",
        position: " LB ",
        nationality: "Canada",
        number: 19,
        starter: true,
        image: "/Images/Davis.png"
    },

    {
        id: 5,
        name: "Dayot Upamecano",
        position: " CB ",
        nationality: "France",
        number: 2,
        starter: true,
        image: "/Images/upamicano.png"
    },

    {
        id: 6,
        name: "Kim Min-jae",
        position: " CB ",
        nationality: "South Korea",
        number: 3,
        starter: false,
        image: "/Images/Min-Jae.png"
    },

    {
        id: 7,
        name: "Jonathan Tah",
        position: " CB ",
        nationality: "Germany",
        number: 4,
        starter: true,
        image: "/Images/Jonathan-Tah.png"
    },

    {
        id: 8,
        name: "Hiroki Ito",
        position: " CB/LB ",
        nationality: "Japan",
        number: 21,
        starter: false,
        image: "/Images/Hiroki-Ito.png"
    },

    {
        id: 9,
        name: "Konrad Laimer",
        position: " RB ",
        nationality: "Austria",
        number: 27,
        starter: true,
        image: "/Images/Konrad-Laimer.png"
    },

    {
        id: 10,
        name: "Raphaël Guerreiro",
        position: " LB ",
        nationality: "Portugal",
        number: 22,
        starter: false,
        image: "/Images/Raphaël-Guerreiro2.png"
    },

    {
        id: 11,
        name: "Josip Stanišić",
        position: " RB ",
        nationality: "Croatia",
        number: 44,
        starter: false,
        image: "/Images/Josip-Stanisic2.png"
    },

    {
        id: 12,
        name: "Joshua Kimmich",
        position: " CDM ",
        nationality: "Germany",
        number: 6,
        starter: true,
        image: "/Images/Kimmich.png"
    },

    {
        id: 13,
        name: "Michael Olise",
        position: " RW ",
        nationality: "France",
        number: 17,
        starter: true,
        image: "/Images/Michael-Olise2.png"
    },

    {
        id: 14,
        name: "Aleksandar Pavlović",
        position: " CDM ",
        nationality: "Germany",
        number: 45,
        starter: true,
        image: "/Images/Aleksandar-Pavlovic2.png"
    },

    {
        id: 15,
        name: "Leon Goretzka",
        position: " CM ",
        nationality: "Germany",
        number: 8,
        starter: false,
        image: "/Images/Leon-Goretzka2.png"
    },

    {
        id: 16,
        name: "Tom Bischof",
        position: " CAM ",
        nationality: "Germany",
        number: 20,
        starter: false,
        image: "/Images/Tom-Bischof2.png"
    },

    {
        id: 17,
        name: "Lennart Karl",
        position: " CAM ",
        nationality: "Germany",
        number: 42,
        starter: false,
        image: "/Images/Lennart-Karl.png"
    },

    {
        id: 18,
        name: "Jamal Musiala",
        position: " CAM ",
        nationality: "Germany",
        number: 10,
        starter: true,
        image: "/Images/Musiala.png"
    },

    {
        id: 19,
        name: "Harry Kane",
        position: " ST ",
        nationality: "England",
        number: 9,
        starter: true,
        image: "/Images/Harry-Kane2.png"
    },

    {
        id: 20,
        name: "Luis Díaz",
        position: " LW ",
        nationality: "Colombia",
        number: 14,
        starter: true,
        image: "/Images/Luis-Diaz.png"
    },

    {
        id: 21,
        name: "Serge Gnabry",
        position: " W/FW ",
        nationality: "Germany",
        number: 7,
        starter: false,
        image: "/Images/Serge-Gnabry2.png"
    },

    {
        id: 22,
        name: "Nicolas Jackson",
        position: " ST ",
        nationality: "Senegal",
        number: 11,
        starter: false,
        image: "/Images/Nicolas-Jackson.png"
    }
]
